import React from 'react';
import { connect } from 'react-redux';
// import {  } from '../../actions/?';
import BottomBar from './bottom_bar';

const mapStateToProps = (state, ownProps) => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BottomBar);


// WEBPACK FOOTER //
// ./lib/components/bottom_bar/bottom_bar_container.jsx